__turbopack_context__.v({
  "item": "styles-module-scss-module__1cdK9W__item",
  "not_available_location_container": "styles-module-scss-module__1cdK9W__not_available_location_container",
  "root": "styles-module-scss-module__1cdK9W__root",
  "tileContainer": "styles-module-scss-module__1cdK9W__tileContainer",
  "title": "styles-module-scss-module__1cdK9W__title",
});
